import 'vite/modulepreload-polyfill'
import noUiSlider from "nouislider";
import "nouislider/dist/nouislider.css";
import "./kslider.css";
import "./kslider-darkmode.css";

$.fn.kslider = function (args) {
    let kslider = $(this);
    let defaults =
        {
            minIndex: 0,
            maxIndex: 0,
            fromIndex: 0,
            toIndex: 0,
            parameterNameFrom: 'sliderFrom',
            parameterNameTo: 'sliderTo'
        };
    let options = $.extend(defaults, args);
    let slider = kslider.find(".kslider-widget")[0];

    function init() {
        noUiSlider.create(slider, {
            range: {
                min: parseInt(options.minIndex),
                max: parseInt(options.maxIndex),
            },
            connect: [false, true, false],
            start: [parseInt(options.fromIndex), parseInt(options.toIndex)],
            step: 1,
            format: {
                from: function (value) {
                    return parseInt(value);
                },
                to: function (value) {
                    return Math.round(value);
                }
            }
        });
        slider.noUiSlider.on("update", updateSlider);
        updateSlider(slider.noUiSlider.get());
        kslider.find('.kslidersubmit a').click(sliderAnzeigenClick);
    }
    function updateSlider(values) {
        kslider.find('.titleFrom').html(getLabel(values[0]));
        kslider.find('.titleTo').html(getLabel(values[1]));
        kslider.find('input[name="' + options.parameterNameFrom + '"]').val(getValue(values[0]))
        kslider.find('input[name="' + options.parameterNameTo + '"]').val(getValue(values[1]))
    }

    function sliderAnzeigenClick(e) {
        kslider.find('form').submit();
        e.preventDefault();
        return false;
    }
    function getSliderdata(index) {
        return kslider.find('.sliderdatas div[data-sliderindex="' + index + '"]')
    }
    function getLabel(index) {
        return getSliderdata(index).data('sliderlabel');
    }
    function getValue(index) {
        return getSliderdata(index).data('slidervalue');
    }

    return this.each(function () {
        init();
    });
}
